<template>
    <div class="mb-8">
        <ol v-if="crumbs.length" class="inline-flex flex-wrap text-xs font-semibold">
            <li
                v-for="(crumb, index) in crumbs"
                class="breadcrumb-item"
                :class="{ active: index != crumbs.length - 1 }">
                    <Link 
                        v-if="index != crumbs.length - 1 && crumb.url" 
                        class="hover:underline" 
                        :href="crumb.url.toLowerCase()"
                    >
                        {{ crumb.title }}
                    </Link>
                    <span class="font-normal text-white" v-else>{{ crumb.title }}</span>
                    <span v-if="index != crumbs.length - 1" class="px-1">&gt;</span>
            </li>
        </ol>
    </div>
</template>

<script>
    export default {
        props: {
            crumbs: Array,
        }
    };
</script>